import React, { useState } from "react";
import {
    Container,
    Row,
    Col,
    Carousel,
} from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";


const floorPlans = [
    {
        id: "TYPE 1",
        title: "3BHK",
        size: "2455 sft",
        facing: "East",
        flat_no: "15",
        image: "/ftp1.png",
        mobile_image: "/mfpt1.png",
        download_image: "/Type1.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 2",
        title: "3BHK",
        size: "2455 sft",
        facing: "West",
        flat_no: "05",
        image: "/ftp2.png",
        mobile_image: "/mfpt2.png",
        download_image: "/Type2.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 3",
        title: "3BHK",
        size: "2455 sft",
        facing: "East",
        flat_no: "16",
        image: "/ftp3.png",
        mobile_image: "/mfpt3.png",
        download_image: "/Type3.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 4",
        title: "3BHK",
        size: "2155 sft",
        facing: "East",
        flat_no: "02",
        image: "/ftp4.png",
        mobile_image: "/mfpt4.png",
        download_image: "/Type4.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 5",
        title: "3BHK",
        size: "2155 sft",
        facing: "West",
        flat_no: "01 & 17",
        image: "/ftp5.png",
        mobile_image: "/mfpt5.png",
        download_image: "/Type5.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 6",
        title: "3BHK",
        size: "2155 sft",
        facing: "West",
        flat_no: "03",
        image: "/ftp6.png",
        mobile_image: "/mfpt6.png",
        download_image: "/Type6.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 7",
        title: "3BHK",
        size: "1855 sft",
        facing: "East",
        flat_no: "10",
        image: "/ftp7.png",
        mobile_image: "/mfpt7.png",
        download_image: "/Type7.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 8",
        title: "3BHK",
        size: "1855 sft ",
        facing: "West",
        flat_no: "09",
        image: "/ftp8.png",
        mobile_image: "/mfpt8.png",
        download_image: "/Type8.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 9",
        title: "3BHK",
        size: "1655 sft",
        facing: "East",
        flat_no: "04, 12 & 18",
        image: "/ftp9.png",
        mobile_image: "/mfpt9.png",
        download_image: "/Type9.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 10",
        title: "3BHK",
        size: "1655 sft",
        facing: "West",
        flat_no: "11 & 19",
        image: "/ftp10.png",
        mobile_image: "/mfpt10.png",
        download_image: "/Type10.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
    {
        id: "TYPE 11",
        title: "3BHK",
        size: "1655 sft",
        facing: "North",
        flat_no: "06, 07, 08, 13 & 14",
        image: "/ftp11.png",
        mobile_image: "/mfpt11.png",
        download_image: "/Type11.jpg",
        points: [
            "Vaastu-Compliant",
            "Designed To Maximize Space",
            "Natural Light",
            "Privacy",
        ],
    },
];

const Facing = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 991px)" });

    const [mobileIndex, setMobileIndex] = useState(0);

    const mobileSlides = [];
    for (let i = 0; i < floorPlans.length; i += 2) {
        mobileSlides.push(floorPlans.slice(i, i + 2));
    }

    return (
        <section
            id="facing"
            className="facing-section"
        >
            <Container>
                {/* Heading */}

                {/* Desktop */}
                {!isMobile ? (
                    <Carousel
                        indicators={false}
                        interval={null}
                        wrap={true}
                        nextIcon={
                            <div className="custom-arrow custom-arrow-right">
                                <FaChevronRight />
                            </div>
                        }
                        prevIcon={
                            <div className="custom-arrow custom-arrow-left">
                                <FaChevronLeft />
                            </div>
                        }
                    >
                        {Array.from({
                            length: Math.ceil(floorPlans.length / 2),
                        }).map((_, slideIndex) => (
                            <Carousel.Item key={slideIndex}>
                                <Row className="justify-content-center g-4">
                                    {floorPlans
                                        .slice(slideIndex * 2, slideIndex * 2 + 2)
                                        .map((item, index) => (
                                            <Col lg={6} key={index}>
                                                <FloorCard item={item} />
                                            </Col>
                                        ))}
                                </Row>
                            </Carousel.Item>
                        ))}
                    </Carousel>

                ) : (
                    <>
                        {/* Mobile Carousel */}
                        <Carousel
                            activeIndex={mobileIndex}
                            onSelect={(selectedIndex) =>
                                setMobileIndex(selectedIndex)
                            }
                            wrap={true}
                            indicators={false}
                            // controls={false}
                            interval={null}
                            nextIcon={
                                <div className="custom-arrow">
                                    <FaChevronRight />
                                </div>
                            }
                            prevIcon={
                                <div className="custom-arrow">
                                    <FaChevronLeft />
                                </div>
                            }
                        >
                            {mobileSlides.map((slide, slideIndex) => (
                                <Carousel.Item key={slideIndex}>
                                    <Row className="g-4">
                                        {slide.map((item, index) => (
                                            <Col xs={12} key={index}>
                                                <FloorCard item={item} mobile />
                                            </Col>
                                        ))}
                                    </Row>
                                </Carousel.Item>
                            ))}
                        </Carousel>

                        {/* Mobile Arrows */}
                        {/* <div className="mobile-arrows">

                            <button
                                onClick={() =>
                                    setMobileIndex((prev) =>
                                        prev === 0
                                            ? mobileSlides.length - 1
                                            : prev - 1
                                    )
                                }
                            >
                                <FaChevronLeft />
                            </button>

                            <button
                                onClick={() =>
                                    setMobileIndex((prev) =>
                                        prev === mobileSlides.length - 1
                                            ? 0
                                            : prev + 1
                                    )
                                }
                            >
                                <FaChevronRight />
                            </button>

                        </div> */}
                    </>
                )}
            </Container>
        </section>
    );
};

const FloorCard = ({ item, mobile }) => {
    const isMobile = useMediaQuery({ query: "(max-width: 991px)" });
    return (
        <div className={`floor-card ${mobile ? "mobile-card" : ""}`}>

            <div className="floor-card-inner">

                {/* Left Image */}
                <div className="floor-image">
                    <img
                        src={isMobile ? item.mobile_image : item.image}
                        alt={item.title}
                    />
                </div>

                {/* Right Content */}
                <div className="floor-content">

                    <h4>{item.id}</h4>

                    <h3>{item.title}</h3>

                    <ul>
                        <li>Unit: {item.title}</li>
                        <li>Facing: {item.facing}</li>
                        <li>Area: {item.size}</li>
                        <li>Flat No: {item.flat_no}</li>
                    </ul>

                    <button>
                        <a
                            href={item.download_image}
                            download
                        >
                            Download Floor Plan
                        </a>
                    </button>

                </div>

            </div>
        </div>
    );
};
export default Facing;